import styles from '@/legacy/components/btn/SubmitBtn.module.scss';

type Props = {
	text: string;
	isValid: boolean;
	isSubmitting: boolean;
	loadingText?: string;
	[key: string]: unknown;
};

const SubmitBtn = ({ text, isValid, isSubmitting, loadingText, ...rest }: Props) => {
	const isDisabled = !isValid || isSubmitting;
	const displayText = isSubmitting && loadingText ? loadingText : text;

	return (
		<button {...rest} className={isDisabled ? styles.disabled : styles.submit} disabled={isDisabled}>
			{isSubmitting && <div className={styles.spinner} />}
			<div className={styles.text}>{displayText}</div>
		</button>
	);
};

export default SubmitBtn;
